import { SuccessStatus } from 'sham-components/shared/success-status';
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-reset-success',
  standalone: true,
  imports: [
    CommonModule,
    SuccessStatus,
    TranslateModule
  ],
  templateUrl: './reset-success.html',
  styleUrl: './reset-success.css',
})
export class ResetSuccessPage {

  router = inject(Router);


  navigateToLogin() {
    this.router.navigate(['/auth/login']);
  }
}